import ClientGroupResource from '@/modules/ta/clientgroup/resources/ClientGroupResource';
import { BaseFormService } from '@/modules/core/form/services/BaseFormService';
import LegacyAssetResource from '@/modules/legacy/ui/resources/LegacyAssetResource';
import { dispatches } from '@/modules/core/app/helpers/store';

export class ClientGroupFormService extends BaseFormService {
  constructor() {
    super(ClientGroupResource);
  }

  /**
   * @param form {BaseForm}
   * @returns {Promise<*>}
   */
  async saveForm(form) {
    const result = await super.saveForm(form);
    dispatches.clientgroup.refreshClientGroupValues();
    dispatches.dashboard.setFilterOptions();
    return result;
  }

  /**
   * @param id
   * @param params
   * @returns {Promise<*>}
   */
  async getForm(id, params = {}) {
    const [form, lightImageUrl] = await Promise.all([
      super.getForm(id, params),
      this.getLogoImage(id),
    ]);

    form[0].light_logo_image_url = lightImageUrl.data || null;
    return form;
  }

  /**
   * @param id
   * @param params
   * @returns {Promise<*>}
   */
  async getItem(id, params = {}) {
    const [data, lightImageUrl] = await Promise.all([
      super.getItem(id, params),
      this.getLogoImage(id),
    ]);

    data.light_logo_image_url = lightImageUrl.data || null;
    return data;
  }

  async getLogoImage(id) {
    return LegacyAssetResource.getAssetUrl(`light_logo_client-group-${id}`);
  }
}

export default new ClientGroupFormService();
